// The address bar is the state: /<repo>/<conversation id>. A reload, a bookmark or a link
// sent to yourself lands in the same place. No router library — two segments do not need one.

export interface Route {
  repo: string | null;
  conversationId: string | null;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function parseRoute(pathname: string): Route {
  const [repo, conversationId] = pathname.split("/").filter(Boolean).map(decodeURIComponent);
  return {
    repo: repo?.startsWith("lab-") ? repo : null,
    conversationId: conversationId && UUID.test(conversationId) ? conversationId : null,
  };
}

export function routePath(route: Route): string {
  if (!route.repo) return "/";
  return `/${encodeURIComponent(route.repo)}${route.conversationId ? `/${route.conversationId}` : ""}`;
}
